<template>
  <v-row class="ma-0">
    <v-col cols="12">
      <h3>{{ $t('Seleção de indicadores') }}</h3>
      <span>{{ $t('Marque os indicadores para a exportação') }}</span>
    </v-col>
    <v-col cols="12" md="6">
      <strong>{{ $t('Quantitativos') }}</strong>
      <v-checkbox
        v-model="selection"
        :label="`1.1 - ${$t('Equipamentos por setor')}`"
        value="1.1 - Equipamentos por setor"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`1.2 - ${$t('Equipamentos Desativados no Período')}`"
        value="1.2 - Equipamentos Desativados no Período"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`1.3 - ${$t('Solicitações por setor')}`"
        value="1.3 - Solicitações por setor"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`1.4 - ${$t('Equipamentos Parados x Tipo de Pendencia')}`"
        value="1.4 - Equipamentos Parados x Tipo de Pendencia"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`1.5 - ${$t('Top 5 equipamentos com mais falhas')}`"
        value="1.5 - Top 5 equipamentos com mais falhas"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`1.6 - ${$t('Prevalência solução defeito')}`"
        value="1.6 - Prevalência solução defeito"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`1.7 - ${$t('Serviços solicitados x concluídos - Período')}`"
        value="1.7 - Serviços solicitados x concluídos - Período"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`1.8 - ${$t(
          'Corretivas solicitadas x executadas - Acumulado'
        )}`"
        value="1.8 - Corretivas solicitadas x executadas - Acumulado"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`1.9 - ${$t('Resolutividade interna')}`"
        value="1.9 - Resolutividade interna"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`1.10 - ${$t('Preventiva x Corretiva')}`"
        value="1.10 - Preventiva x Corretiva"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`1.11 - ${$t(
          'Preventivas agendadas x executadas - Acumulado'
        )}`"
        value="1.11 - Preventivas agendadas x executadas - Acumulado"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`1.12 - ${$t('Calibrações agendadas x executadas')}`"
        value="1.12 - Calibrações agendadas x executadas"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`1.13 - ${$t(
          'Segurança elétrica agendada x executada - Acumulado'
        )}`"
        value="1.13 - Segurança elétrica agendada x executada - acumulado"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`1.14 - ${$t('Histórico de migração de equipamentos')}`"
        value="1.14 - Histórico de migração de equipamentos"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`1.15 - ${$t('Ordens de serviço por responsável - Período')}`"
        value="1.15 - Ordens de serviço por responsável - Período"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-if="institution.departmentTypes.includes(1)"
        v-model="selection"
        :label="`1.16 - ${$t('Solicitações por Oficina')}`"
        value="1.16 - Solicitações por Oficina"
        hide-details
      ></v-checkbox>
    </v-col>
    <v-col cols="12" md="6">
      <strong>{{ $t('Tempos') }}</strong>
      <v-checkbox
        v-model="selection"
        :label="`2.1 - ${$t('Tempo de máquina parada')}`"
        value="2.1 - Tempo de máquina parada"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`2.2 - ${$t(
          'Tempo médio entre falhas por equipamento padrão'
        )}`"
        value="2.2 - Tempo médio entre falhas por equipamento padrão"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`2.3 - ${$t('Tempo médio entre falhas por equipamento')}`"
        value="2.3 - Tempo médio entre falhas por equipamento"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`2.4 - ${$t('Atendimento x Previsão atendimento')}`"
        value="2.4 - Atendimento x Previsão atendimento"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`2.5 - ${$t('Chamados Corretivos Atendidos no Prazo')}`"
        value="2.5 - Chamados atendidos no prazo"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`2.6 - ${$t('Resolução x Previsão resolução')}`"
        value="2.6 - Resolução x Previsão resolução"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`2.7 - ${$t('Chamados Corretivos Resolvidos no Prazo')}`"
        value="2.7 - Chamados resolvidos no prazo"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`2.8 - ${$t('Tempo de atendimento interno por setor')}`"
        value="2.8 - Tempo de atendimento interno por setor"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`2.9 - ${$t('Tempo de atendimento interno por criticidade')}`"
        value="2.9 - Tempo de atendimento interno por criticidade"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`2.10 - ${$t('Tempo produtivo')}`"
        value="2.10 - Tempo produtivo"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`2.11 - ${$t('Tempo produtivo por setor')}`"
        value="2.11 - Tempo produtivo por setor"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`2.12 - ${$t(
          'Tempo médio de resolução interna por criticidade'
        )}`"
        value="2.12 - Tempo médio de resolução interna por criticidade"
        hide-details
      ></v-checkbox>
    </v-col>
    <v-col cols="12">
      <v-divider></v-divider>
    </v-col>
    <v-col cols="12" md="6">
      <strong>{{ $t('Custos Manutenção') }}</strong>
      <v-checkbox
        v-model="selection"
        :label="`3.1 - ${$t('Custos por peça avulsa')}`"
        value="3.1 - Custos por peça avulsa"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`3.2 - ${$t('Custos por serviço avulso')}`"
        value="3.2 - Custos por serviço avulso"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`3.3 - ${$t('Custo por setor')}`"
        value="3.3 - Custo por setor"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`3.4 - ${$t('Custo por ID equipamento')}`"
        value="3.4 - Custo por ID equipamento"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`3.5 - ${$t('Custo Evitado')}`"
        value="3.5 - Custo evitado"
        hide-details
      ></v-checkbox>
    </v-col>
    <v-col cols="12" md="6">
      <strong>Controle de qualidade</strong>
      <v-checkbox
        v-model="selection"
        :label="`4.1 - ${$t('Notas das avaliações de Chamados')}`"
        value="4.1 - Notas das avaliações O.S."
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`4.2 - ${$t('Ranking fornecedor')}`"
        value="4.2 - Ranking fornecedor"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="selection"
        :label="`4.3 - ${$t('Adesão ao módulo de chamados')}`"
        value="4.3 - Adesão ao módulo de chamados"
        hide-details
      ></v-checkbox>
    </v-col>

    <v-col cols="12">
      <v-card-actions class="justify-space-between">
        <v-btn text @click="$emit('back')">
          <v-icon>mdi-chevron-left</v-icon>
          {{ $t('Voltar') }}
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn text @click="submit">
          {{ $t('Continuar') }}
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'SelectInstStep',

  props: {
    selectionProp: Array,
  },

  watch: {
    selectionProp() {
      this.selection = this.selectionProp
    },
  },

  created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.selection = this.selectionProp
  },

  data() {
    return {
      institution: {},
      selection: [],
    }
  },

  methods: {
    submit() {
      if (this.selection.length > 0) {
        this.$emit('next', this.selection)
      } else {
        this.$toast.warning('Selecione ao menos um indicador para prosseguir')
      }
    },
  },
}
</script>

<style scoped></style>
